import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import type { ProviderZonesList, CreateProviderZoneDto, ProviderZone } from "@reactive-resume/dto";
import qs from "qs";
const getProviderZones = async (page?: number) => {
  const response = await axios.get<{ page: number; data: ProviderZone[] }>("/provider/zones", {
    params: { page },
    paramsSerializer: (params) => qs.stringify(params),
  });
  console.log(response.data);
  return response.data;
};

export const useProviderZones = (page?: number) => {
  const {
    data: providerZones,
    isPending: loading,
    error,
  } = useQuery({
    queryKey: ["providerZones", page],
    queryFn: () => getProviderZones(page),
  });

  return { providerZones, loading, error };
};

export const useDeleteProviderZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => axios.delete(`/provider/zone/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providerZones"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
